import { FeatureFlagVariables } from "../../../../../common/featureFlag";

export const AI_ASSISTANT_NAME_FLAG_KEY = FeatureFlagVariables.aiAssistantName;

export const AI_ASSISTANT_ANIMATED_ICON_FLAG_KEY = FeatureFlagVariables.aiAssistantAnimatedIcon;
export const AI_ASSISTANT_ANIMATED_ICON_DEFAULT_VALUE = false;
